module.exports = __webpack_public_path__ + "static/img/软件授权.fad7d6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Doc/assets/imgs/软件授权.png
// module id = ALO+
// module chunks = 0